import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FAQSection from '../components/FAQSection';
import SEOHead from '../components/SEOHead';
import { PAGE_SEO } from '../data/pageSeo';
import { buildFaqPageStructuredData } from '../data/siteSeo';

const FAQPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEOHead
        title={PAGE_SEO['/faq'].title}
        description={PAGE_SEO['/faq'].description}
        canonical={PAGE_SEO['/faq'].canonical}
        structuredData={buildFaqPageStructuredData()}
      />
      <Header />

      <main className="flex-1" style={{ paddingTop: '5rem' }}>
        <FAQSection />
      </main>

      <Footer />
    </div>
  );
};

export default FAQPage;